
// STATUS KEYS (MATCH BACKEND)

export const OC_STATUS_KEYS = {
  DISPATCHED: 'dispatched',
  TO_DISPATCH: 'to_dispatch',
  WAREHOUSE: 'warehouse',
  PROCESSED: 'processed',
  PENDING: 'pending',
  PROCESSING: 'processing',
  ERROR: 'error',
  REJECTED: 'rejected',
  REPROCESSED: 'reprocessed',
  NO_INSERTED: 'no_inserted'
}

// STATUS OPTIONS (FILTER UI)

export const STATUS_OPTIONS = [
  { key: OC_STATUS_KEYS.PENDING, label: 'Pendiente' },
  { key: OC_STATUS_KEYS.PROCESSED, label: 'Procesado' },
  { key: OC_STATUS_KEYS.WAREHOUSE, label: 'Bodega' },
  { key: OC_STATUS_KEYS.TO_DISPATCH, label: 'Por despachar' },
  { key: OC_STATUS_KEYS.DISPATCHED, label: 'Despachado' },
  { key: OC_STATUS_KEYS.ERROR, label: 'Error' },
  { key: OC_STATUS_KEYS.REJECTED, label: 'Rechazado' },
  { key: OC_STATUS_KEYS.REPROCESSED, label: 'Reprocesado' },
  { key: OC_STATUS_KEYS.NO_INSERTED, label: 'No insertado' }
]

// STATUS UI MAP (TABLE / BADGE)

export const STATUS_UI_MAP = {
  pending: {
    label: 'PENDIENTE',
    className: 'oc-pending-style'
  },
  processed: {
    label: 'PROCESADO',
    className: 'oc-process-style'
  },
  warehouse: {
    label: 'BODEGA',
    className: 'oc-pending-bill-style'
  },
  to_dispatch: {
    label: 'POR DESPACHAR',
    className: 'oc-billed-style'
  },
  dispatched: {
    label: 'DESPACHADO',
    className: 'oc-dispatched-style'
  },
  error: {
    label: 'ERROR',
    className: 'oc-error-style'
  },
  rejected: {
    label: 'RECHAZADO',
    className: 'oc-rejected-style'
  },
  reprocessed: {
    label: 'REPROCESADO',
    className: 'oc-reprocessed-style'
  },
  no_inserted: {
    label: 'NO INSERTADO',
    className: 'oc-not-inserted-style'
  }
}

// STATUS LABEL → KEY (FILTER BACK)

export const STATUS_LABEL_TO_KEY = Object.fromEntries(
  STATUS_OPTIONS.map(o => [o.label, o.key])
)

// TABS

export const OC_TAB_VALUES = {
  ORDER: 'ORDER',
  ERROR: 'ERROR',
  REQUESTED: 'REQUESTED',
  INVOICED: 'INVOICED'
}


export const OC_TABS = [
  {
    value: OC_TAB_VALUES.ORDER,
    label: 'Orden de compra',
    icon: 'upload_file',
    iconSize: 20,
    filled: false
  },
  {
    value: OC_TAB_VALUES.ERROR,
    label: 'Orden de compra',
    icon: 'upload_file',
    iconSize: 20,
    filled: true
  },
  {
    value: OC_TAB_VALUES.REQUESTED,
    label: 'Pedido',
    icon: 'shopping_cart',
    iconSize: 20,
    filled: true
  },
  {
    value: OC_TAB_VALUES.INVOICED,
    label: 'Facturado',
    icon: 'receipt',
    iconSize: 20,
    filled: true
  }
]

// Estados donde se puede IGNORAR

export const IGNORABLE_STATUSES = [
  OC_STATUS_KEYS.ERROR
]

// Estados donde se puede ENVIAR

export const SENDABLE_STATUSES = [
  OC_STATUS_KEYS.PENDING,
  OC_STATUS_KEYS.REPROCESSED
]

// Estados donde se puede REPROCESAR

export const REPROCESSABLE_STATUSES = [
  // OC_STATUS_KEYS.ERROR,
  OC_STATUS_KEYS.PENDING,
  OC_STATUS_KEYS.PROCESSED,
  OC_STATUS_KEYS.REPROCESSED,
  OC_STATUS_KEYS.NO_INSERTED
]

// Estados donde se puede RECHAZAR

export const REJECTABLE_STATUSES = [
  OC_STATUS_KEYS.ERROR
]


// LINE ERROR MAP (BACKEND → UI)

export const OC_LINE_ERROR_MAP = {
  'Producto/paquete no encontrado': {
    short: 'PROD/PACK NO ENC.',
    full: 'Producto o paquete no encontrado'
  },
  'Precio no coincide': {
    short: 'PRECIO INVÁLIDO',
    full: 'El precio no coincide con el esperado'
  },
  'Producto descontinuado': {
    short: 'DESCONTINUADO',
    full: 'Producto descontinuado'
  },
  'Diferencia en el empaque': {
    short: 'EMPAQUE INVÁLIDO',
    full: 'Existe una diferencia en el empaque'
  },
  'Paquete bloqueado para la cadena': {
    short: 'BLOQUEADO',
    full: 'Empaque bloqueado para la cadena'
  }
}

// DATA DEFAULT

export const DEFAULT_DATA = {
  lines: [],
  status: {},
  totals: {},
  counts: {}
}


// DATA CARD FILLRATE DETAILS

export const OC_SUMMARY_CARDS = [
  {
    key: 'oc_original',
    title: 'OC ORIGINAL',
    icon: 'shopping_cart',
    iconFilled: true
  },
  {
    key: 'ubiqua',
    title: 'PEDIDO PROCESADO',
    icon: 'assignment_turned_in',
    iconFilled: false
  },
  {
    key: 'invoice',
    title: 'FACTURADO',
    icon: 'receipt_long',
    iconFilled: false
  }
]


// HEADER DETAILS CLIENTS PROCESS

export const OC_CLIENT_HEADER_CONFIG = {
  normal: {
    titleKey: 'customer',
    cards: [
      {
        icon: 'barcode_scanner',
        label: 'Código:',
        valueKey: 'client_db_ref'
      },
      {
        icon: 'account_box',
        label: 'Usuario:',
        valueKey: 'salesman',
        filled: true
      },
      {
        icon: 'event',
        label: 'Fecha de emisión:',
        valueKey: 'captured_at',
        format: 'date'
      }
    ]
  },

  error: {
    titleKey: 'client_name',
    cards: [
      {
        icon: 'barcode_scanner',
        label: 'Código:',
        valueKey: 'client_db_ref'
      },
      {
        icon: 'event',
        label: 'Fecha:',
        valueKey: 'date',
        format: 'date'
      }
    ]
  }
}


// INDICADORES INDEX 

export const OC_INDICATORS_CONFIG = [
  {
    key: 'received',
    title: 'Órdenes de compra recibidas',
    icon: 'inbox',
    iconClass: 'indicator-icon-received',
    label: 'OC recibidas'
  },
  {
    key: 'processed',
    title: 'Órdenes procesadas correctamente',
    icon: 'check_circle',
    iconClass: 'indicator-icon-success',
    label: 'Procesadas'
  },
  {
    key: 'error',
    title: 'Órdenes con error',
    icon: 'warning',
    iconClass: 'indicator-icon-error',
    label: 'Con error'
  },
  {
    key: 'reprocessed',
    title: 'Órdenes reprocesadas',
    icon: 'refresh',
    iconClass: 'indicator-icon-warning',
    label: 'Reprocesadas'
  },
  {
    key: 'avgProcessed',
    title: 'Porcentaje promedio procesado',
    icon: 'bar_chart',
    iconClass: 'indicator-icon-info',
    label: '% procesado prom.',
    suffix: '%'
  }
]

// TRACE SUMMARY

export const TRACE_SUMMARY_CARDS = [
  {
    label: '# ORDEN DE COMPRA',
    valueKey: 'purchase_order_db_ref'
  },
  {
    label: '# PEDIDO UBIQUA',
    valueKey: 'order_id'
  },
  {
    label: '# PEDIDO ERP',
    valueKey: 'sales_order_db_ref'
  },
  {
    label: '# FACTURA',
    valueKey: 'invoice_db_ref'
  }
]

// Date Card Details Priority

export const LAST_ACTIVITY_PRIORITY = [
  'invoice',
  'sales_order',
  'order',
  'purchase_order'
]


// ERROR STATUS

export const OC_ERROR_MESSAGES = {
  PROCESS_ORDER_ERROR: 'Error al procesar la orden',
  NO_INSERTED_PREFIX: 'No insertado en ERP',
  NO_INSERTED_FALLBACK:
    'No fue posible insertar la orden en el ERP. Intente nuevamente o contacte al administrador si el problema persiste.'
}
